<template>
  <div>
    <transition name="fade" mode="out-in">
      <div id="loading-cart" v-show="loadingCart">
        <div class="loading-contents">
          <Spinner color="#3982c4" />
        </div>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div class="row wrap-cart" v-show="!loadingCart">
        <div class="col-sm-9 cart-items">
          <div class="cart-content shadow-box">
            <div class="alert alert-warning" role="alert">
              <label><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Please review your order for correctness before checking out.</label>
            </div>

            <div class="main-wrapper">
              <div class="header">
                <h3 class="hd-1">Products</h3>
                <h3 class="hd-2">Quantity</h3>
                <h3 class="hd-3">Price</h3>
                <button class="hd-4 btn btn-default" @click.prevent="removeAll()" v-show="Object.keys(cart.items).length > 0" :disabled="Object.keys(cart.items).length === 0">Remove All</button>
              </div>

              <hr class="col-sm-12">

              <div v-if="cart.items.length">
                <div class="main line-item-wrapper" v-for="cartItem in cart.items" :key="cartItem.product.id">
                  <div class="product-image">
                    <a :href="cartItem.product.url" :title="cartItem.product.name" target="_blank">
                      <img
                        :src="ImageResize(cartItem.product.image_url !== null && cartItem.product.image_url !== undefined ? cartItem.product.image_url : '/img/default-product-img.png', 100)"
                        :alt="cartItem.product.name"
                      >
                    </a>
                  </div>
                  <div class="product-details">
                    <h4>{{ cartItem.product.name }}</h4>
                    <p>Sku: {{ cartItem.product.sku }}</p>
                    <p>Availability: {{ formatStockMsg(cartItem.product.stock_level) }}</p>
                    <p class="label label-info" v-if="cartItem.product.status">{{ cartItem.product.status }}</p>
                  </div>

                  <div class="product-qty">
                    <input v-if="!cartItem.kit_id && !isKitItem(cartItem)"
                      class="form-control"
                      type="number"
                      v-model="cartItem.quantity.value"
                      :step="productIncrement(cartItem.product)"
                      :disabled="updatingQuantities"
                      :min="productIncrement(cartItem.product)"
                      :max="cartItem.product.minMaxQuantity && cartItem.product.minMaxQuantity.max > 0 ? cartItem.product.minMaxQuantity.max : false"
                      @change="qtyHasChanged(cartItem.id, cartItem)"
                    >
                    <span v-if="cartItem.kit_id || isKitItem(cartItem)">{{ cartItem.quantity.value }}</span>
                  </div>
                  <div class="product-price">
                    <p><strong>{{ cartItem.price ? cartItem.price.formatted : '$0.00' }}</strong></p>
                    <p class="price-per-unit">{{ cartItem.price_per_unit ? cartItem.price_per_unit.formatted : '$0.00' }}{{ `/${ cartItem.quantity.unit }`}}</p>
                  </div>
                  <div class="product-actions">
                    <button :id="cartItem.id" :class="`col-xs-5 btn ${qtyChanged.includes(cartItem.id) ? 'btn-primary' : 'btn-default'}`" @click.prevent="ValidateQuantityValue(cartItem)" :disabled="updatingQuantities" v-if="!cartItem.kit_id && !isKitItem(cartItem)">Update</button>
                    <button class="col-xs-5 btn btn-default" v-if="!cartItem.kit_id" @click.prevent="removeCartItem(cartItem)" :disabled="loading">Remove</button>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 text-center" v-else>
                <p>You have no items in your cart.</p>
              </div>
            </div>

            <hr>

            <div v-show="$root.isMobile && Object.keys(cart.items).length > 0">
              <button class="hd-4 btn btn-link btn-block" @click.prevent="removeAll()" :disabled="Object.keys(cart.items).length === 0">Remove All</button>
              <hr>
            </div>

            <div class="cart-footer">
              <div class="add-product">
                <div class="form-group">
                  <label>Find/Add a Product</label>
                  <vToken2
                    v-model="appendedProduct"
                    :closeOnSelect="false"
                    :options="productSearchOptions"
                    @token2-select="handleProductSelection"
                  />
                </div>
              </div>

              <div class="cont-shopping text-right">
                <a href="/shop/powder-coating-colors" class="btn btn-block btn-blue">Continue Shopping</a>
              </div>
            </div>
          </div>

          <div v-show="!$root.isMobile">
            <h2>
              Trending Colors
              <a :href="`/shop/powder-coating-colors`">
                See All
              </a>
            </h2>

            <div class="product-wrap">
              <div class="row">
                <div class="product-cards custom-product-cards">
                  <Product
                    v-for="(product, index) in trendingColors"
                    class="custom-product-card"
                    :key="product.id"
                    :product="product"
                    :index="index"
                    :orderFreeSwatchBtn="true"
                    :isSearchPage="false"
                    @add-swatch-to-cart="addSwatchToCart"
                  />
                </div>
              </div>
            </div>

          </div>
        </div>

        <CartDetails
          :subTotal="cart.items_total.amount"
          :totalItems="cart.items.length"
          :cartItems="cart.items"
          :has-invalid-quantities="hasInvalidQuantities"
          :updating-quantities="updatingQuantities"
          @setExpressCheckoutData="setExpressCheckoutData"
        />

        <CookiesDisabledModal />

        <ExpressCheckoutModal :expressCheckoutData="expressCheckoutData" />
      </div>
    </transition>

    <RemoveAllProductsModal />
  </div>
</template>

<script>
  import CartDetails from './CartDetails.vue';
  import product from '../../mixins/product';
  import Product from "../shop/products/Product.vue";
  import OutOfStockModal from "./OutOfStockModal.vue";
  import images from '../../mixins/images';
  import vToken2 from '../global/Token2.vue';
  import CookiesDisabledModal from '../modals/CookiesDisabledModal.vue';
  import Spinner from '../Spinner.vue';
  import ExpressCheckoutModal from '../modals/ExpressCheckoutModal.vue';
  import RemoveAllProductsModal from '../modals/RemoveAllProductsModal.vue';

  export default {
    name: 'shopping-cart',

    components: {
      Product,
      CartDetails,
      OutOfStockModal,
      vToken2,
      CookiesDisabledModal,
      Spinner,
      ExpressCheckoutModal,
      RemoveAllProductsModal,
    },

    mixins: [product, images],

    data() {
      return {
        qtyChanged: [],
        appendedProduct: {},
        updatingQuantities: false,
        trendingColors: window._PR?.trendingColors || [],
        formErrors: [],
        formSuccess: [],
        loading: false,
        loadingCart: false,
        updatedItem: {},
        itemAmtOverride: false,
        showInformationModal: false,
        productSearchOptions: {
          placeholder: 'Type name or SKU here...',
          multiple: false,
          ajax: {
            url: '/api/proxify/domains/prismatic/shop/products' +
              '?anycat=pris_all_colors,pris_coating_kits,pris_swatches,pris_gear,pris_equipment,pris_free_swatches' +
              '&show_variants=true' +
              '&fields=id,name,sku,product_id,variant_id,swatch_product.id,swatch_product.enabled,swatch_product.hero_only,pricing.**,stock_level',
            delay: 150,
            cache: false,
            data(params) {
              return {
                q: params.term,
              };
            },
            processResults(data, params) {
              return {results: data.data.filter(item => !(item.stock_level == 'long_term_out_of_stock'))};
            },
          },
          templateResult(item) {

            if (item.loading) {
              return item.text;
            }
            if(item.stock_level !== 'long_term_out_of_stock'){
              return `${ item.name }-${ item.sku }`;
            }

          },
          templateSelection(item) {
            return item.text;
          },
        },
        expressCheckoutData: {},
      };
    },

    computed: {
      hasInvalidQuantities() {
        return Object.values(this.cart.items).some(item => item.product.quantityNotice !== false) || false;
      },
      cart: {
        get() {
          return this.$store.getters.localCart;
        },
        set(value) {
          this.setLocalCart(value);
        },
      },
    },

    mounted() {
      let cookieEnabled = (navigator.cookieEnabled) ? true : false;

      if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
      }

      if (!cookieEnabled) {
        $('#cookiesDisabledModal').modal('show');
      }

      if (this.cart.applied_discounts.length) {
        this.formSuccess = [];

        for (const appliedDiscount of this.cart.applied_discounts) {
          this.getDiscountMessage(appliedDiscount, this.cart);
        }
      }

      window.appVariables.bus.$on('cart-updated', (responseData) => {
        if (responseData.applied_discounts.length) {
          this.formSuccess = [];

          for (const appliedDiscount of responseData.applied_discounts) {
            this.getDiscountMessage(appliedDiscount, responseData);
          }
        }

        // this.products = Object.assign({}, responseData.items);
        this.loadCartItems(responseData.items);
      });

    },

    watch: {
      cart: {
        deep: true,
        handler() {
          this.loadCartItems(this.cart.items);
        }
      },

      itemAmtOverride() {
        if (this.itemAmtOverride) {
          this.updateQuantity(this.updatedItem);
        }
      }
    },

    methods: {
      productIncrement(product) {
        return product.minMaxQuantity && product.minMaxQuantity.min > 0 ? product.minMaxQuantity.min : 1;
      },
      addSwatchToCart(swatch) {
        this.$emit("add-swatch-to-cart", swatch);
      },

      // pass the checkout data to the Vue component.
      setExpressCheckoutData(data) {
        if (data) {
          this.expressCheckoutData = data;
        }
      },

      qtyHasChanged(id, item) {
        this.updatedItem = item;
        this.qtyChanged.push(id);
      },

      formatStockMsg(text) {
        return text ? (text.charAt(0).toUpperCase() + text.substr(1).toLowerCase()).replaceAll('_', ' ') : '';
      },

      loadCartItems(items) {
        // this.products = Object.assign({}, items);

        Object.keys(this.cart.items).map(i => {
          this.cart.items[i] = this.AssignProductAttributes(this.cart.items[i]);
        });

      },

      /**
       * @method ValidateQuantityMinMax
       * @param { Object } cartItem
       * @author Sebastian Inman <sinman@nicindustries.com>
       * Validates the quantity of a cart item on the input method.
       * This method is only responsible for detecting invalid quantities in real-time.
       * If the quantity value is not within the products min/max range, it assigns an
       * error directly to the product.
       */

      // ValidateQuantityMinMax(cartItem) {
      //   cartItem.quantity.value = Math.round(cartItem.quantity.value);

      //   this.ValidateProductQuantity(cartItem.quantity.value , cartItem.product.minMaxQuantity)
      //     .then(() => { cartItem.product.quantityNotice = false })
      //     .catch(error => { cartItem.product.quantityNotice = error });

      //   this.updateQuantity(cartItem);
      // },


      /**
       * @method ValidateQuantityValue
       * @param { Object } cartItem
       * @author Sebastian Inman <sinman@nicindustries.com>
       * Validates the quantity of a cart item on the blur method.
       * This method checks to make sure the quantity value is not zero, and is not less
       * than the minimum allowed quantity - if it is, reset the value to the minimum allowed quantity.
       * After that, we once again validate the quantity to make sure it exists within the min/max range.
       * If it isn't within the range, we assign the error directly to the product.
       */

      ValidateQuantityValue(cartItem) {
        cartItem.quantity.value = Math.round(cartItem.quantity.value);

        // Force the quantity to the minimum allowed quantity if the
        // value is empty or is less than the allowed quantity value.
        // if(cartItem.quantity.value === '' || parseInt(cartItem.quantity.value) < parseInt(cartItem.product.minMaxQuantity.min)) {

        //   cartItem.quantity.value = parseInt(cartItem.product.minMaxQuantity.min);
        //   cartItem.product.quantityNotice = false;

        // }

        // Force the quantity to the maximum allowed quantity if
        // the value exceeds the maximum allowed quantity value.
        // if(parseInt(cartItem.quantity.value) > parseInt(cartItem.product.minMaxQuantity.max) && parseInt(cartItem.product.minMaxQuantity.max) > 0) {

        //   cartItem.quantity.value = parseInt(cartItem.product.minMaxQuantity.max);
        //   cartItem.product.quantityNotice = false;

        // }

        /**
         * We're setting the minmax default to null here. This is because we're not needing to currently validate the min/max range,
         * in part, due to the email me when available functionality.
         */
        let minMax = {
          min: null,
          max: null,
        }

        if (parseFloat(cartItem.quantity.value) <= 0) {
          this.invalidQtyInformationModal(cartItem);
          return;
        }

        this.ValidateProductQuantity(cartItem.quantity.value , minMax)
          .then(() => this.updateQuantity(cartItem))
          .catch(error => { cartItem.product.quantityNotice = error });

          this.qtyChanged = [];
      },


      /**
       * @method AssignProductAttributes
       * @param { Object } product
       * @author Sebastian Inman <sinman@nicindustries.com>
       * This method assigns the necessary attributes needed for validating
       * the products quantity min/max values.
       */

      AssignProductAttributes(item) {

        let isStandardProduct = false;
        let isNotKitItem = false;

        item.product.quantityNotice = false;
        item.product.status = '';

        if (item.product.sku.substring(0,3) !== 'APP' &&
            item.product.sku.substring(0,2) !== 'SE' &&
            item.product.sku.substring(0,2) !== 'K-') {
          isStandardProduct = true;
        }

        if (!item.product.kit_id && !this.isKitItem(item.product)) {
          isNotKitItem = true;
        }

        if (item.product.discontinued || !item.product.enabled && isNotKitItem) {
          item.product.status = 'Product No Longer Available.';
        }

        if (item.stock_level !== 'in_stock' && item.price.amount < 1 && isStandardProduct && isNotKitItem) {
          item.product.status = `Due To High Demand - This Swatch Temporarily Out of Stock.
          Your order may be delayed for production time.`;
        }

        if (item.stock_level === 'low' && isStandardProduct && isNotKitItem) {
          item.product.status = 'Low Stock!';
        }

        if (item.stock_level === 'out_of_stock' && isStandardProduct && isNotKitItem) {
          item.product.status = 'Due To High Demand - Temporarily Out of Stock.';
        }

        item.product.minMaxQuantity = this.ProductMinMaxQuantity(item.product);
        item.product.isAkzo = item.product.categories.filter(cat => cat.code === 'pris_akzonobel').length > 0;

        return item;
      },

      isInventoryValid(sku) {
        const excludedSkus = /^SE-|^APP-|^K-/i;
        return sku.match(excludedSkus);
      },

      isKitItem(item) {
        if (this.cart.items.length) {
          let kitItems = this.cart.items.filter(product => !!product.kit_id);

          if (kitItems.length && kitItems[0].kit_id === item.product_id) {
            return true;
          }
        }

        return false;
      },

      isSwatchItem(item) {
        let name = item.product.name.toLowerCase();

        return name.includes('swatch') && !name.includes('set');
      },

      removeAll() {
        setTimeout(() => {
          $("#removeAllProductsModal").modal("show");
        }, 300);
      },

      async removeCartItem(item) {
        this.loading = true;
        this.formSuccess = [];
        this.formErrors = [];
        const url = `/api/proxify/domains/prismatic/shop/cart/items/${ item.id }`;

        try {
          this.updatingQuantities = true;
          let response = await axios.delete(url, {data: {}});
          let responseData = {};

          if (response.data != undefined) {
            responseData = response.data;
          } else {
            responseData = response;
          }

          window.appVariables.bus.$emit('cart-updated', responseData);

          if (responseData.applied_discounts.length) {
            this.formSuccess = [];

            for (const appliedDiscount of responseData.applied_discounts) {
              this.getDiscountMessage(appliedDiscount, responseData);
            }
          }

        window.dataLayer.push({
          'event': 'removeFromCart',
          'ecommerce': {
            'remove': {
              'products': [{
                'name': item.product.name,
                'id': item.product.sku,
                'price': item.price.amount,
                'brand': item.domain,
                'category': item.product.url ? item.product.url.split('/')[4] : 'powder-coating-equipment',
                'quantity': item.quantity.value,
              }],
            },
          },
        });

          // this is for GA4
          dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
              currency: "USD",
              value: parseFloat(responseData.items_total.amount),
              items: [{
                item_id: item.product.sku,
                item_name: item.product.name,
                affiliation: this.$root.me.customer_id ? this.$root.me.customer_id : undefined,
                coupon: undefined,
                currency: "USD",
                discount: parseFloat(item.savings.amount),
                index: undefined,
                item_brand: "Prismatic",
                item_category: item.product.type,
                item_list_id: undefined,
                item_list_name: undefined,
                item_variant: undefined,
                location_id: "Cart",
                price: parseFloat(item.price.amount),
                quantity: parseFloat(item.quantity.value)
              }]
            }
          });
        } catch(error) {
          console.error(error);
        } finally {
          this.loading = false;
          this.updatingQuantities = false;
        }
      },

      async handleProductSelection(product) {
        this.loading = true;

        if (!this.$root.isLoggedIn && this.$root.totalCartItems >= 50) {
          this.$root.lockedTitle = 'Unable to Add Product';
          this.$root.lockedMessage = `There is a limit of 50 items that can be added to the cart when not logged in. \n
          Please login to add more items.`;
          this.$root.okCancel = false;
          $('#informationModal').modal('show');

          this.loading = false;

          return;
        }

        this.formSuccess = [];
        this.formErrors = [];
        let url = `/api/proxify/domains/prismatic/shop/cart`;
        let productId = product.id;

        let data = {
          product_id: productId,
          variant_id: product.variant_id,
          quantity: {value: '1'},
        };

        try {
          let response = await axios.post(url, data);
          let responseData = {};

          responseData = response.data !== undefined ? response.data : response;

          window.appVariables.bus.$emit('cart-items-added', {
            product: product,
            cart: responseData,
            data: data,
            multipleItems: false,
            swatchItem: false,
            showBanner: false,
          });

          // this.products = responseData.items;

          if (responseData.applied_discounts.length) {
            this.formSuccess = [];

            for (const appliedDiscount of responseData.applied_discounts) {
              this.getDiscountMessage(appliedDiscount, responseData);
            }

          }

          // this is for GA4
          dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              currency: "USD",
              value: parseFloat(this.$root.cart.items_total.amount),
              items: [{
                item_id: this.$root.itemJustAddedToCart.product.sku,
                item_name: this.$root.itemJustAddedToCart.product.name,
                affiliation: this.$root.me.customer_id,
                coupon: undefined,
                currency: "USD",
                discount: parseFloat(this.$root.itemJustAddedToCart.product.savings.amount),
                index: undefined,
                item_brand: "Prismatic",
                item_category: this.$root.itemJustAddedToCart.product.pricing[0].starting_quantity.unit,
                item_list_id: undefined,
                item_list_name: undefined,
                item_variant: undefined,
                location_id: "Cart",
                price: parseFloat(this.$root.itemJustAddedToCart.product.pricing[0].price_per_base_quantity.amount),
                quantity: 1
              }]
            }
          });
        } catch(error) {
          console.error(error);
          const apiMessage = error.response.data.message;

          if (apiMessage.includes('Cannot add more')) {
            this.$root.lockedTitle = 'Unable to Add Product';
          }

          this.$root.lockedMessage = apiMessage;
          this.$root.okCancel = false;
          $('#informationModal').modal('show');
        } finally {
          Object.keys(this.cart.items).map(i => {
            this.cart.items[i] = this.AssignProductAttributes(this.cart.items[i]);
          });

          this.loading = false;
        }
      },

      swatchInformationModal(item) {
        this.showInformationModal = true;
        item.quantity.value = 2;
        this.$root.lockedTitle = 'Unable to Update Swatch Quantity';
        this.$root.lockedMessage = `${ item.quantity_available > 2
          ? 'Swatches have a quantity limit of 2 per swatch. '
          : item.product.name + ' ' + item.product.sku + 'has a limit of 1. ' }` +
          'If you would like to order more than 2 qty of this swatch, please contact us at 1-866-774-7628.';
        this.$root.okCancel = false;
        $('#informationModal').modal('show');
        this.$root.$on('cancel-action', () => {
          this.showInformationModal = false;
        });
      },

      itemInformationModal(item) {
        this.showInformationModal = true;
        this.$root.lockedTitle = 'Requested Product Quantity Unavailable';
        this.$root.lockedMessage = `You have great taste! We only have ${ item.quantity_available }
          left of the ${ item.quantity.value } you are looking for of ${ item.product.name } ${ item.product.sku }.
          We can get ${ item.quantity_available } to you right away and ship the rest when it becomes available
          at no additional charge! The whole order will be billed at the time of checkout.<br><br>
          Do you still want to add ${ item.quantity.value } of ${ item.product.name } to your cart?`;
        this.$root.okCancel = true;
        this.$root.okCancelText = ['Yep', 'Nope'];
        this.$root.okCancelProduct = item;
        this.$root.okCancelCartItems = this.cart.items;
        this.$root.okCancelAddToCart = false;
        $('#informationModal').modal('show');
        item.product.quantityNotice = false;
        this.$root.$on('ok-action', () => {
          this.itemAmtOverride = true;
          this.showInformationModal = false;
        });
        this.$root.$on('cancel-action', () => {
          this.showInformationModal = false;
        });
      },

      akzoInformationModal(item) {
        this.showInformationModal = true;
        this.$root.lockedTitle = 'Unable to Update Quantity';
        this.$root.lockedMessage = `${item.product.name + ' ' + item.product.sku + ' has a minimum amount of 2 and a max limit of 50. ' }` +
          'If you would like to order more than 50 qty of this product, please contact us at 1-866-774-7628.';
        this.$root.okCancel = false;
        $('#informationModal').modal('show');
        this.$root.$on('cancel-action', () => {
          this.showInformationModal = false;
        });
      },

      invalidQtyInformationModal(item) {
        this.showInformationModal = true;
        this.$root.lockedTitle = 'Invalid Quantity';
        this.$root.lockedMessage = `${item.product.name + ' ' + item.product.sku + ' must have a quantity larger than 0.'}`;
        this.$root.okCancel = false;
        $('#informationModal').modal('show');
        this.$root.$on('cancel-action', () => {
          this.showInformationModal = false;
        });
      },

      async updateQuantity(item) {
        this.showInformationModal = false;

        if (this.isSwatchItem(item) && parseFloat(item.quantity.value) > 2) {
          this.swatchInformationModal(item);
        }

        if (
          !this.isInventoryValid(item.product.sku)
          && !this.itemAmtOverride
          && parseFloat(item.quantity.value) > item.quantity_available
        ) {
          this.itemInformationModal(item);
        }

        if (item.product.isAkzo && (parseFloat(item.quantity.value) > 50 || parseFloat(item.quantity.value) < 2)) {
          this.akzoInformationModal(item);
        }

        this.formSuccess = [];
        this.formErrors = [];

        const url = `/api/proxify/domains/prismatic/shop/cart/items/${ item.id }`;

        if (!this.showInformationModal || this.itemAmtOverride) {
          this.updatingQuantities = true;
          const inputAmt = item.quantity.value;
          let correctedAmount = inputAmt;

          if (inputAmt % 1 != 0) {
            correctedAmount = Math.trunc(inputAmt);
            item.quantity.value = correctedAmount;
            this.updateQuantity(item);
          }

          const data = {quantity: {
            value: correctedAmount
          }};

          try {
            let response = await axios.patch(url, data);
            let responseData = {};

            responseData = response.data != undefined ? response.data : response;

            this.loadCartItems(responseData.items);

            window.appVariables.bus.$emit('cart-updated', responseData);

            if (responseData.applied_discounts.length) {
              this.formSuccess = [];

              for (const appliedDiscount of responseData.applied_discounts) {
                this.getDiscountMessage(appliedDiscount, responseData);
              }
            }
          } catch(error) {
            console.error(error);
          } finally {
            this.updatingQuantities = false;
            item.product.quantityNotice = false;
            this.itemAmtOverride = false;
          }
        }
      },

      getDiscountMessage(appliedDiscount, responseData) {
        let successMessage = '';
        if (appliedDiscount.coupon_code) {
          if (appliedDiscount.type === 'fixed') {
            successMessage = 'The Coupon "' + appliedDiscount.coupon_code + '" has been added. You are saving ' + responseData.savings.formatted + ' off your order!';
          } else if (appliedDiscount.type === 'free_shipping') {
            if (appliedDiscount.mas_shipping_code === 'PRIS - 1 DAY') {
              successMessage = 'The Coupon "' + appliedDiscount.coupon_code + '" has been added. 1 day shipping has been discounted!';
            } else if (appliedDiscount.mas_shipping_code === 'PRIS - 2 DAY') {
              successMessage = 'The Coupon "' + appliedDiscount.coupon_code + '" has been added. 2 day shipping has been discounted!';
            } else if (appliedDiscount.mas_shipping_code === 'PRIS - 3 DAY') {
              successMessage = 'The Coupon "' + appliedDiscount.coupon_code + '" has been added. 3 day shipping has been discounted!';
            } else if (appliedDiscount.mas_shipping_code === 'PRIS-INTL 1-2') {
              successMessage = 'The Coupon "' + appliedDiscount.coupon_code + '" has been added. International shipping has been discounted!';
            }
          } else {
            successMessage = 'The Coupon "' + appliedDiscount.coupon_code + '" has been added. You are saving ' + appliedDiscount.percentage + '%!';
          }
        } else {
          if (appliedDiscount.type === 'fixed') {
            successMessage = 'The Coupon "' + appliedDiscount.display_name + '" has been added. You are saving ' + responseData.savings.formatted + ' off your order!';
          } else if (appliedDiscount.type === 'free_shipping') {
            if (appliedDiscount.mas_shipping_code === 'PRIS - 1 DAY') {
              successMessage = 'The Coupon "' + appliedDiscount.display_name + '" has been added. You are getting free 1 day shipping!';
            } else if (appliedDiscount.mas_shipping_code === 'PRIS - 2 DAY') {
              successMessage = 'The Coupon "' + appliedDiscount.display_name + '" has been added. You are getting free 2 day shipping!';
            } else if (appliedDiscount.mas_shipping_code === 'PRIS - 3 DAY') {
              successMessage = 'The Coupon "' + appliedDiscount.display_name + '" has been added. You are getting free 3 day shipping!';
            } else if (appliedDiscount.mas_shipping_code === 'PRIS-INTL 1-2') {
              successMessage = 'The Coupon "' + appliedDiscount.display_name + '" has been added. You are getting free international shipping!';
            }
          } else {
            successMessage = 'The Coupon "' + appliedDiscount.display_name + '" has been added. You are saving ' + appliedDiscount.percentage + '%!';
          }
        }
        if (!this.formSuccess.includes(successMessage)) {
          this.formSuccess.push(successMessage);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #loading-cart {
    text-align: center;
    position: relative;
    height: 100vh;
    z-index: 0;

    .loading-contents {
      h1 {
        position: fixed;
        width: 100%;
      }
    }
  }

  .alert {
    margin-bottom: 0;
  }

  .wrap-cart {
    .cart-items {
      .main-wrapper {
        grid-template-areas:
        'hd'
        'line-item-wrapper';
        display: grid;
        overflow: hidden;

        .header {
          grid-area: hd;
          display: grid;
          gap: 10px;
          grid-template-areas: 'hd-1 hd-2 hd-3 hd-4';
          grid-template-columns: 37% 18% auto;

          h3 {
            color: #c4c4c4;
          }

          .hd-1 {
            grid-area: hd-1;
          }
          .hd-2 {
            grid-area: hd-2;
          }
          .hd-3 {
            grid-area: hd-3;
          }

          .hd-4 {
            grid-area: hd-4;
            height: min-content;
            font-size: 1rem;
            margin: 10px 0 0 0;
          }
        }

        .line-item-wrapper {
          display: grid;
          gap: 10px;
          grid-template-columns: 15% 20% 15% 15% 30%;
          grid-template-areas:
          'product-image product-details product-qty product-price product-actions';

          p, h4 {
            margin: 0;
          }

          .product-image {
            grid-area: product-image;
            margin: 0 auto;

            img {
              width: 100px;
            }
          }

          .product-details {
            grid-area: product-details;

            p {
              font-size: 12px;
            }

            .label {
              display: inline-block;
              white-space: normal;
            }
          }

          .product-qty {
            grid-area: product-qty;

            input {
              display: inline-block;
            }
          }

          .product-price {
            grid-area: product-price;
            margin: 0 auto;
            text-align: left;

            .price-per-unit{
              color: #c4c4c4;
            }
          }

          .product-actions {
            grid-area: product-actions;
            text-align: center;
            justify-content: center;
            align-items: baseline;
            display: flex;

            button {
              font-size: 1rem;
              margin: 0 5px;
            }
          }
        }
      }

      .cart-footer {
        display: grid;
        grid-template-columns: 65% 35%;
      }
    }
  }


  @media (max-width: 768px) {
    .wrap-cart .cart-items {
      position: inherit;
      display: inline-block;

      .main-wrapper {
        hr {
          display: none;
        }

        .header {
          display: none;
        }

        .line-item-wrapper {
          grid-template-columns: auto;
          grid-template-areas:
          'product-image'
          'product-details'
          'product-qty'
          'product-price'
          'product-actions';

          border-bottom: 1px solid #e7e7e7;
          padding-bottom: 25px;
          margin-bottom: 25px;
        }

        .line-item-wrapper:last-child {
          border-bottom: none;
          padding-bottom: 0;
          margin-bottom: 0;
        }
      }

      .cart-footer {
        display: inline-block;
        width: 100%;

        .add-product {
          max-width: inherit;
        }
      }
    }

    #loading-cart {
      margin-top: -25px;
      height: 50vh;

      .loading-contents {
        z-index: 1;
      }
    }
  }
</style>
